//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            // 图片路径
            imgUrl:'',
            list_tab: ['未完成', '已完成'],
            tab: '未完成',
            item_list:[],
        }
    },
    mounted(){
        // 获取图片路径
        this.imgUrl =  sessionStorage.getItem('ossPath')
        this.getList()
    },
    activated(){
        this.getList()
    },
    methods:{
        // 获取数据
        getList(){
            if(this.tab == '未完成'){
                this.getData(0)
            }
            if(this.tab == '已完成'){ 
                this.getData(2)
            }
        },
        async getData(i){
            let sid = sessionStorage.getItem('sid')
            let data = {
                status: i,
                sid:sid
            }
            let res = await this.$HTTP.HttpPost('/member/Appointment/getOrderList',data)
            this.item_list = res.data.data.data
            this.item_list.forEach(item => {
                let time = item.appoint_day * 1000
                let date = new Date(time)
                var YY = date.getFullYear() + '-';
                var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
                item.time = MM + DD + ' ' + item.appoint_times 
                item.Time = YY + MM + DD + ' ' + item.appoint_times

                item.picture = this.imgUrl + item.picture
            })
            console.log(this.item_list);
        },

        // 标签切换
        changeTab(s){
            if(this.tab == s){
                return
            }
            this.tab = s
            this.getList(s)
        },
        // 详情
        toDetails(i){
            // if(i.status == 0 || i.status == 1){
            //     this.$router.push({
            //     name:'/yuyuedetails',
            //     params:{
            //         info:i
            //     }
            //     })
            // }
            this.$router.push({
                name:'/yuyuedetails',
                params:{
                    info:i
                }
                })
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/home/two.vue